import React, { forwardRef, useEffect, useImperativeHandle } from "react";
import { PDFExport } from "@progress/kendo-react-pdf";
import dayjs from 'dayjs';

const PrintInventoryInfoTwo = forwardRef((props, ref) => {
  const { countSheetData } = props;
  const userClaims = localStorage.getItem('UserClaims');
  let pdfExportComponent;

  const pageTemplate = (props) => {
    return (
      <>
        <div
          style={{
            position: "absolute",
            bottom: "10px",
            fontSize: "18px",
            width: '100%',
            textAlign: 'center'
          }}
        >
          Page {props.pageNum} of {props.totalPages}
        </div>
      </>
    )
  };

  const handlePrint = () => {
    if (pdfExportComponent && countSheetData.length > 0) {
      pdfExportComponent.save();
    }
  };

  useImperativeHandle(ref, () => ({
    handlePrint
  }));

  return (
    <>
      <PDFExport
        paperSize="A4"
        landscape={false}
        margin="1mm"
        scale={0.56}
        ref={(pdfExport) => (pdfExportComponent = pdfExport)}
        pageTemplate={pageTemplate}
        fileName={`${props.CountSheetName} (${props.InventoryDate})`}
        repeatHeaders={true}
      >
        <section className="form-section">
          <div style={{ justifyContent: "center" }}>
            <div>
              <div className="banner">
                <img style={{ width: "100%" }} src="./items.png" />
                <div className="banner-content">
                  <h4> {JSON.parse(userClaims)?.restaurent_name}</h4>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      marginTop: "10px",
                    }}
                  >
                    <h4>Inventory Date:</h4>
                    <h4>
                      {props.InventoryDate}
                    </h4>
                  </div>
                  <div
                    style={{
                      marginTop: "10px",
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <h4>{props.CountSheetName}</h4>
                    <span style={{ color: "#a8a8a8" }}>|</span>
                    <h4>
                      Printed:{" "}
                      <span style={{ fontSize: "20px" }}>
                        {dayjs().format('MM/DD/YYYY hh:mmA')}
                      </span>
                    </h4>
                  </div>
                </div>
              </div>
              <div className="form-container">
                <div className="form-body">
                  <div class="print-table-container" style={{ marginBottom: '15px' }}>
                    <table>
                      <thead>
                        <tr>
                          <th>Category</th>
                          <th>Sub Category</th>
                          <th>Product</th>
                          <th>Common Name</th>
                          <th>Report By</th>
                          <th>Prev Count</th>
                          <th>Prev Value</th>
                          <th>Count</th>
                          <th>Value</th>
                          <th>Change</th>
                        </tr>
                      </thead>
                      <tbody>
                        {countSheetData.map((item, i) =>
                          <tr key={i}>
                            <td>{item["Category"]}</td>
                            <td>{item["Sub Category"]}</td>
                            <td>{item["Product"]}</td>
                            <td>{item["Common Name"]}</td>
                            <td>{item["Report By"]}</td>
                            <td>{item["Prev Count"]}</td>
                            <td>{item["Prev Value"]}</td>
                            <td>{item["Count"]}</td>
                            <td>{item["Value"]}</td>
                            <td>{item["Change"]}</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </PDFExport>
    </>
  );
});

export default PrintInventoryInfoTwo;
